export default __webpack_public_path__ + "static/media/simulate-jungle-icon.b28dfa2b.png";